import React from 'react';


function ContactLocationCard({ icon, text, url }) {


    return (
        <a href={url} className="contactCard contactCard--location" target="_blank" rel="noopener noreferrer">
            {icon}
            <p>{text}</p>
        </a>
    );
}


export default ContactLocationCard;